<div class="identification"></div>

<div class="dialog">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <h3 class="title-margin-top">{{ 'dialog_substructure_title' | translate }}</h3>
    <mat-card>
      <mat-grid-list cols="10" rowHeight="60px" gutterSize="20px">
        <mat-grid-tile colspan="2">
          <mat-form-field>
            <mat-label color="accent">{{ 'common_field_code' | translate }}</mat-label>
            <input matInput formControlName="code" minlength="2" required />
            <mat-error *ngIf="formCrls.code.invalid">{{ 'dialog_substructure_error_code' | translate }}</mat-error>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="3">
          <mat-form-field>
            <mat-label>{{ 'common_field_label' | translate }}</mat-label>
            <input matInput formControlName="displayName" required />
            <mat-error *ngIf="formCrls.displayName.invalid">{{ 'dialog_substructure_error_label' | translate }}</mat-error>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="2" *ngIf="currentItem?.structureTypeId">
          <mat-form-field>
            <mat-label>{{ 'dialog_substructure_field_owner' | translate }}</mat-label>
            <input matInput disabled [value]="currentItem?.ownerId ? currentItem.owner : CONSTANTS.GENERIC_RESOURCE_AUTHOR" />
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="2" *ngIf="currentItem?.substructureTypeId">
          <mat-form-field>
            <mat-label>{{ 'dialog_substructure_field_creator' | translate }}</mat-label>
            <input matInput disabled [value]="currentItem?.ownerId ? currentItem.creator : CONSTANTS.GENERIC_RESOURCE_ACU_AUTHOR" />
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-card>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="form?.value" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
